// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPaymentInvoiceSummaryResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingPaymentInvoiceSummaryApiResponse = {
	id: number;
	date: string;
};

export type BillingPaymentInvoiceSummary = {
	id: number;
	date: DateTime;
};

export function hydrateBillingPaymentInvoiceSummary(data: BillingPaymentInvoiceSummaryApiResponse): BillingPaymentInvoiceSummary {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
	};
}